import React from 'react';

// Title and opening paragraph shared by the information pages
const PageIntro = ({ title, children, note }) => (
  <header className="max-w-2xl">
    <h1 className="font-serif text-4xl font-semibold leading-tight tracking-[-0.01em] md:text-5xl">{title}</h1>
    {children && <p className="mt-4 text-lg leading-relaxed text-ink-soft">{children}</p>}
    {note && <p className="mt-3 text-sm text-ink-soft">{note}</p>}
  </header>
);

export default PageIntro;
